import { store } from "../store/store";
import axios from "axios";
import jwt from "jsonwebtoken";

function throw_error_object(error) {
  var error_object = {};

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    error_object.response = {
      data: error.response.data,
      status: error.response.status,
    }
  }
  if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    error_object.request = error.request;
  }
  if (error.message) {
    // Something happened in setting up the request that triggered an Error
    error_object.error_message = error.message;
  }
  error_object.config = error.config;
  throw {
    "error": error_object,
  }
}
export const communityCan = (action, domain_name, resource) => {
  // guard function to decide whether a given action can be perforrmed
  // given current access token.
  var decoded_token = jwt.decode(store.state.accessToken)

  for (var role_entry of decoded_token["iam:roles"]) {
    // Check if domain matches.  ADMIN of id 0 matches all
    if ((role_entry["domain_name"] == "ADMIN" && role_entry["role"] == "ADMIN")
      || (role_entry["domain_name"] == domain_name)) {
      for (var permission of role_entry["permissions"]) {
        // Check for action match
        if (permission["action"] == "hilda:*"
          || permission["action"] == "hilda:" + action) {
          // check resource match
          if (permission["resource"] == "*"
            || permission["resource"] == resource) {
            return true;
          }
        }
      }
    }
  }
  return false;

}

export default class CommunityService {

  constructor() {
    this.STATUS_OK = 0;
    this.ERROR_COMMUNITY_NAME_INVALID = 1;
    this.ERROR_COMMUNITY_NAME_TAKEN = 2;
  }

  loadCommunities() {
    return store.dispatch('getAccessToken').then(token => {
      return axios.get('/community',
        { headers: { Authorization: "Bearer " + token } })
        .then(resp => {
          console.log("Storing list of communities");
          this.communities_loaded_at = new Date();
          return this.communities = resp.data;
        });
    });
  }
  getAvailableDomains() {
    return store.dispatch('getAccessToken').then(token => {
      return axios.get(`/iam/v1/domains`, {
        headers: {
          "Authorization": "Bearer " + token,
          "Content-Type": 'application/json'
        }
      }).then(resp => {
        if (resp.data) {
          return resp.data.domains.map(d => {
            return {
              "id": d.id,
              "name": d.name,
            }
          }).map(d => { // Access level
            d.writable = false;
            if (d.name != "ADMIN" // Domain 0 is ADMIN, and we do not allow communities here
              && communityCan('create_community', d.name, "*")) {
              d.writable = true;
            }
            return d;
          });
        }
        else {
          return [];
        }
      }).catch(err => {
        console.log("Error during getAvailableDomains call");
        console.log(err);
      });
    });
  }

  async getTimelines(data, source) {
    return await store.dispatch('getAccessToken').then(async (token) => {
      return await axios.post("/community/timelines", {
        "startDate": data.startDate,
        "endDate": data.endDate,
        "query": data.queries
      },
        {
          cancelToken: source ? source.token : null,
          headers: {
            "Authorization": "Bearer " + token,
          }
        }
      ).then(resp => resp.data)
        .catch(err => err)
    })
  }

  async getVennData(data, source) {
    return await store.dispatch('getAccessToken').then(async (token) => {
      return await axios.post("/community/venn-kpis", {
        "startDate": data.startDate,
        "endDate": data.endDate,
        "query": data.queries
      },
        {
          cancelToken: source ? source.token : null,
          headers: {
            "Authorization": "Bearer " + token,
          }
        }
      ).then(resp => resp.data)
        .catch(err => err)
    })
  }
  // TODO, consider moving to project service!
  addCommunity(id, data) {
    return axios.post(`/projects/${id}/communities`, JSON.stringify(data), {
      headers: {
        "Authorization": "Bearer " + this.token,
        "Content-Type": 'application/json'
      }
    })
      .then(resp => resp.data.community)
      .catch(throw_error_object)
  }
  /*
    Returns
  */
  checkCommunityName(name) {
    // Only alphanumeric characters and whitespace
    const regExp = /^[a-zA-Z0-9 ]*$/;
    if (!name.match(regExp)) {
      return this.ERROR_COMMUNITY_NAME_INVALID;
    }
    return this.STATUS_OK;
  }

  _checkCommunityNameAvailibility(namespace, name) {
    for (let c of this.communities) {
      if (c.key.namespace == namespace && c.key.name == name) {
        return this.ERROR_COMMUNITY_NAME_INVALID;
      }
    };
    return this.STATUS_OK;
  }

  checkCommunityNameAvailibility(namespace, name) {
    // not loaded or older than 1 min
    if (this.communities == undefined ||
      ((new Date) - this.communities_loaded_at) > 60 * 1000) {
      return this.loadCommunities().then(() => {
        return this._checkCommunityNameAvailibility(namespace, name);
      })

    } else {
      return new Promise((resolve, reject) => {
        resolve(this._checkCommunityNameAvailibility(namespace, name));
      });
    }
  }

  displayNameForm(router, navigateTo, community, isNameAlreadyTaken, dialog, beingSaved, communityId, projectId) {
    return router.push({
      name: 'ProjectCommunityNameForm', params: {
        communityName: community.label || community,
        navigateTo: navigateTo,
        navigatedFrom: navigateTo,
        projectId: projectId,
        formState: {
          query: community.query,
          is_temporary: false
        },
        communityId: communityId,
        beingSaved: beingSaved,
        dialog: true,
        isNameAlreadyTaken: isNameAlreadyTaken
      }
    });
  }


  async getInfluenceKPIs(data, source) {
    var payload = {
      "startDate": data.startDate,
      "endDate": data.endDate,
      "query": data.query
    }
    return await store.dispatch('getAccessToken').then(async (token) => {
      return await axios.post("/community/influence",
        payload,
        {
          // cancelToken: source.token,
          headers: {
            "Authorization": "Bearer " + token,
          }
        }
      ).then(resp => resp)
        .catch(throw_error_object)
    })
  }

  async getMicroInfluenceKPIs(data, source) {
    var payload = {
      "startDate": data.startDate,
      "endDate": data.endDate,
      "query": data.query
    }
    return await store.dispatch('getAccessToken').then(async (token) => {
      return await axios.post("/community/micro-influence",
        payload,
        {
          // cancelToken: source.token,
          headers: {
            "Authorization": "Bearer " + token,
          }
        }
      ).then(resp => resp)
        .catch(throw_error_object)
    })
  }

  async getExpressionKPIs(data, source) {
    return await store.dispatch('getAccessToken').then(async (token) => {
      var payload = {
        "startDate": data.startDate,
        "endDate": data.endDate,
        "query": data.query,
      };
      if (data.field_of_expression) {
        payload["expression_field"] = data.field_of_expression;
      }

      return await axios.post("/community/expression",
        payload,
        {
          // cancelToken: source.token,
          headers: {
            "Authorization": "Bearer " + token,
          }
        }
      ).then(resp => resp)
        .catch(throw_error_object)
    })
  }

  async getExpositionKPIs(data, source) {
    return await store.dispatch('getAccessToken').then(async (token) => {
      return await axios.post("/community/exposition", {
        "startDate": data.startDate,
        "endDate": data.endDate,
        "query": data.query,
        "exposed_to": data.exposed_to
      },
        {
          // cancelToken: source.token,
          headers: {
            "Authorization": "Bearer " + token,
          }
        }
      ).then(resp => resp)
        .catch(throw_error_object)
    })
  }
}
